import React, { useState, useEffect } from 'react';
import SitePageBody from '../components/common/SitePageBody';
import { getSitePage } from '../services/api';
import SEO from '../components/SEO';
import FroggySpinner from '../components/common/FroggySpinner';
import { CORE_KEYWORDS } from '../constants/seoKeywords';
import '../styles/policy-page.css';

const PrivacyPolicyPage = () => {
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState('Privacy Policy');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const data = await getSitePage('privacy-policy');
        setContent(data.content_md);
        setTitle(data.title);
        setError(false);
      } catch (err) {
        console.error('Failed to fetch privacy policy content:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="policy-page">
        <div className="policy-page-container" style={{ textAlign: 'center', padding: 'var(--ff-space-5xl)' }}>
          <FroggySpinner size="lg" label="Loading privacy policy" />
        </div>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="policy-page">
        <div className="policy-page-container">
          <h1 className="policy-page-title">Privacy Policy</h1>
          <p className="policy-page-text">
            This content is temporarily unavailable. Please try again later.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEO
        title="Privacy Policy - Feeling Froggy"
        description="Read our privacy policy to understand how we collect, use, and protect your personal information. GDPR compliant, secure data handling, and transparency."
        canonical="https://feelingfroggy.llc/privacy-policy"
        keywords={CORE_KEYWORDS}
      />
      {/* 2026-07-18 security fix: backend field is `content_md`, was
          rendered as raw HTML via dangerouslySetInnerHTML with no
          sanitization. That stays gone. 2026-09-08: this page's prod
          content_md is HTML, not markdown, and bare react-markdown
          escaped the tags into visible text — SitePageBody renders
          markdown AND sanitized raw HTML through the one shared,
          tested pipeline. */}
      <div className="policy-page">
        <div className="policy-page-container">
          <h1 className="policy-page-title">{title}</h1>
          <SitePageBody className="policy-page-content" title={title} content={content} />
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
